import { ContextClassBase } from '../../core/service/RuntimeContext.js';

var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unknown"] = 0] = "Unknown";
    ConnectionStatus[ConnectionStatus["Connected"] = 1] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 2] = "Disconnected";
})(ConnectionStatus || (ConnectionStatus = {}));
var NetworkType;
(function (NetworkType) {
    NetworkType[NetworkType["Unknown"] = 0] = "Unknown";
    NetworkType[NetworkType["Cellular_2G"] = 1] = "Cellular_2G";
    NetworkType[NetworkType["Cellular_3G"] = 2] = "Cellular_3G";
    NetworkType[NetworkType["Cellular_4G"] = 3] = "Cellular_4G";
    NetworkType[NetworkType["Cellular_5G"] = 4] = "Cellular_5G";
    NetworkType[NetworkType["Wifi"] = 5] = "Wifi";
    NetworkType[NetworkType["Other"] = 6] = "Other";
    NetworkType[NetworkType["None"] = 7] = "None";
})(NetworkType || (NetworkType = {}));
class IMNetApi extends ContextClassBase {
}

export { ConnectionStatus, IMNetApi, NetworkType };
//# sourceMappingURL=IMNetApi.js.map
